import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { IconButton } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import BarChartIcon from '@mui/icons-material/BarChart';
import { FC, useState } from 'react';

export const LaborDemandDataItem = 'Labor demand data';
export const ForecastSimulationItem = 'Forecast simulation';

const options = [
    {
        id: LaborDemandDataItem,
        title: LaborDemandDataItem,
    },
    {
        id: ForecastSimulationItem,
        title: ForecastSimulationItem,
    }
];

export type ChatMenuItemProps = {
    id: string;
    title: string;
};

type ChatMenuProps = {
    handleSelectChatMenuItem: (chatMenuItemProps: ChatMenuItemProps) => void;
};

const ChatMenu: FC<ChatMenuProps> = ({ handleSelectChatMenuItem }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedItem, setSelectedItem] = useState<ChatMenuItemProps>(options[0]);
    const [openChatMenu, setOpenChatMenu] = useState<boolean>(false);
    const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setOpenChatMenu(true);
    };
    
    const handleMenuItemClick = (
        menuItem: ChatMenuItemProps,
    ) => {
        setSelectedItem(menuItem);
        setAnchorEl(null);
        setOpenChatMenu(false);
        handleSelectChatMenuItem(menuItem);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpenChatMenu(false);
    };

    return (
        <div>
            <IconButton
                id="chat-menu-button"
                aria-controls={openChatMenu ? 'chat-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openChatMenu ? 'true' : undefined}
                onClick={handleClickListItem}
            >
                {selectedItem && selectedItem.id === LaborDemandDataItem ?
                    <BarChartIcon />
                    :
                    selectedItem && selectedItem.id === ForecastSimulationItem ?
                        <TimelineIcon />
                        :
                        <></>
                }
            </IconButton>
            <Menu
                id="chat-menu"
                anchorEl={anchorEl}
                open={openChatMenu}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'chat-menu-button',
                    role: 'listbox',
                }}
                style={{ zIndex: 100000 }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option.id}
                        selected={option.id === selectedItem.id}
                        onClick={() => handleMenuItemClick(option)}
                    >
                        {option.title}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}

export default ChatMenu;